import { extendTheme } from "@chakra-ui/react";
import colors from "./colors";

import { alertAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(alertAnatomy.keys);

const PRIMARY = "#089A7A";

const solid = definePartsStyle((props) => {
    const bg =
        props.status === "error" ? "#E53E3E" :
            props.status === "warning" ? "#DD6B20" :
                props.status === "info" ? "#3182CE" : "#089A7A"; // success + domyślnie zielony
    return {
        container: {
            bg,
            color: "white",
            borderRadius: "lg",
            boxShadow: "xl",
        },
        icon: { color: "white" },
        title: { fontWeight: 700 },
        description: { opacity: 0.95 },
    };
});

const Alert = defineMultiStyleConfig({
    variants: { solid },
});

const theme = extendTheme({
    colors,
    fonts: {
        heading: "'Ubuntu', sans-serif",
        body: "'Ubuntu', sans-serif",
    },
    components: {
        Alert,
        Button: {
            baseStyle: {
                borderRadius: 0,
                fontWeight: 600,
                fontFamily: 'Poppins',
                transition: "background-color .15s ease, color .15s ease, transform .15s ease",
                _hover: {
                    bg: PRIMARY,
                    transform: "translateY(-1px)",
                    boxShadow: "md",
                    filter: "brightness(0.97)"
                },
                _active: { bg: PRIMARY, color: "white" },
                _disabled: { _hover: { bg: undefined, color: undefined } },
            },
            defaultProps: { colorScheme: "brand.500" }
        },
        Input: {
            variants: {
                outline: {
                    field: {
                        bg: 'white',
                        borderRadius: 0,
                        borderColor: '#9D9D9D',
                        _focus: {
                            borderColor: PRIMARY,
                            boxShadow: `0 0 0 1px ${PRIMARY}`,
                        },
                        _hover: {
                            borderColor: PRIMARY,
                        },
                    },
                },
            },
        },
        Table: {
            baseStyle: {
                th: {
                    fontWeight: '700',
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                },
                td: {
                    fontFamily: 'Rubik',
                },
            },
        },
        Textarea: {
            baseStyle: {
                _focus: {
                    border: "2px solid #089A7A !important",
                    boxShadow: "none !important",
                },
                border: "1px solid #909090 !important"
            },
        },
        FormLabel: {
            baseStyle: {
                fontFamily: "Poppins",
                fontWeight: 400,
                fontStyle: "normal",
                fontSize: "16px",
                lineHeight: "100%",
                letterSpacing: "0"
            }
        }
    }
});

export default theme;



